export function concatUrls(left: string, right: string): string {
  if (left.endsWith("/")) left = left.substring(0, left.length - 1);
  if (right.startsWith("/")) right = right.substring(1);
  return left + "/" + right;
}
